import { JSX, useContext, useEffect, useState} from "react";
import { Link, useLocation, useRouteMatch } from "react-router-dom";
import { NetworkIntegrityRouteState, RouteMatchParams } from "../models";
import { NetworkIntegrityGenerateReportPanel } from "./NetworkIntegrityGenerateReportPanel";
import { NetworkIntegrityGapImpactReportPanel } from "./NetworkIntegrityGapImpactReportPanel";
import { NetworkIntegrityContext } from "@app/projects/network-assessment/network-integrity/NetworkIntegrityContext";
import { NetworkIntegrityAdequacyImpactType } from "@app/projects/enumerators";
import ProjectRunConfiguration from "@app/projects/projectRunConfiguration";
import Page from "@app/shared/Page";
import PageHeader from "@app/shared/PageHeader";
import PageHeaderRight from "@app/shared/PageHeaderRight";
import PageInner from "@app/shared/PageInner";
import PageSection from "@app/shared/PageSection";

const NetworkIntegrityReportsPage = (): JSX.Element => {

  const routeMatch = useRouteMatch<RouteMatchParams>();
  const { projectId, projectRunConfigurationId, providerType } = routeMatch.params;
  const locationState = useLocation<NetworkIntegrityRouteState>().state;
  const initialProviderType = locationState?.initialProviderType ?? providerType;
  const [projectRunConfiguration, setProjectRunConfiguration] = useState<ProjectRunConfiguration>(locationState?.runConfiguration);
  const networkIntegrityContext = useContext(NetworkIntegrityContext);
  const project = networkIntegrityContext.project;

  const isProviderDetailAvailable =
    routeMatch.params.impactType === NetworkIntegrityAdequacyImpactType.CriticalAlertGaps
      ? !!project?.showNetworkIntegrityCriticalAlerts
      : !!project?.showNetworkIntegrityAttestationBasedAlerts;

  useEffect(() => {
    if (!project || projectRunConfiguration) return;
    const runConfig = project.projectRunConfigurations?.find(
      (rc) => rc.projectRunConfigurationId === Number(projectRunConfigurationId)
    );
    setProjectRunConfiguration(runConfig);
  }, [project, projectRunConfigurationId, projectRunConfiguration]);

  return (
    <Page documentTitle="Network Integrity Reports">
      <PageInner>
        <PageHeader iconName="Download Cloud v1" title="Create Downloadable Reports">
          <PageHeaderRight>
            <Link
              className="qes-button qes-button-secondary"
              type="button" id="network-integrity-providers__back"
              to={{ pathname: `/projects/${projectId}/network-integrity`, state: { initialProviderType: initialProviderType, runConfiguration: projectRunConfiguration } }}
            >
              Return to Project
            </Link>
          </PageHeaderRight>
        </PageHeader>

        <PageSection>
          {routeMatch.params.impactType
            ? <NetworkIntegrityGapImpactReportPanel {...routeMatch.params} isProviderDetailAvailable={isProviderDetailAvailable} />
            : <NetworkIntegrityGenerateReportPanel {...routeMatch.params} />}
        </PageSection>
      </PageInner>
    </Page>
  );
}

export { NetworkIntegrityReportsPage };